/**
 * @ Author: Your name
 * @ Create Time: 2020-04-28 17:47:03
 * @ Modified by: Your name
 * @ Modified time: 2020-06-10 17:27:04
 * @ Description:
 */

import router from '@core/router/'
export default {
  state: {
    tabList: [],
    tabActive: '',
    freshState: true
  },
  getters: {
    tabList (state) {
      return state.tabList
    },
    tabActive (state) {
      return state.tabActive
    },
    activeTab (state) {
      debugger
      const activeTab = state.tabList.find(tab => tab.name === state.tabActive)
      return activeTab || {}
    },
    freshState: state => {
      return state.freshState
    }
  },
  mutations: {
    setTabList (state, data) {
      debugger
      state.tabList = data
    },
    pushTabList (state, data) {
      debugger
      state.tabList.push(data)
    },
    setTabActive (state, data) {
      state.tabActive = data.name
    },
    closeTab (state, data) {

    },
    setFreshState (state, data) {
      state.freshState = false
      setTimeout(() => {
        state.freshState = true
      }, 0)
    }
  },
  actions: {
    clearTabList ({commit}) {
      commit('setTabList', [])
    },
    openTab ({dispatch, commit, state}, value) {
      debugger
      const tabList = [].concat(state.tabList)
      const tabInfo = tabList.find(tab => tab.name === value.name)
      if (!tabInfo) {
        commit('pushTabList', {...value})
      } else {
        // commit('setTabList', tabList)
      }
      commit('setTabActive', value)
    },
    removeTab ({commit, state}, value) {
      const tabList = [].concat(state.tabList)
      const tabIndex = tabList.findIndex(tab => tab.name === value)
      if (tabList.length > 1) {
        tabList.splice(tabIndex, 1)
        commit('setTabList', tabList)
        const targetTab = tabList[tabIndex === 0 ? 0 : tabIndex - 1]
        if (value === state.tabActive) {
          router.push(targetTab)
        }
      }
      // commit('setFreshState')
    },
    setFreshState ({commit}) {
      commit('setFreshState')
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-base/store/tabs.js